var plPL = {
	"codeBlock.copied": "Skopiowano",
	"codeBlock.copyLabel": "Kopiuj",
	"inlineCodeBlock.copied": "Skopiowano",
	"inlineCodeBlock.copyLabel": "Kopiuj kod wewnętrzny"
};

export { plPL as default };
